import { __decorate, __extends } from "tslib";
import { attachShadowTemplate, coerceBoolean, CustomElement, ensureChildren, FoundationProperty, isDefined, upgradeProperty } from '@tyler-components-web/core';
import { tylIconArrowRight } from '@tylertech/tyler-icons/standard';
import { TylerIconRegistry } from '../icon';
import { LinearProgressComponent } from '../linear-progress';
import { ListComponent } from '../list';
import { ListDropdownAware } from '../list-dropdown/list-dropdown-aware';
import { PopupComponent } from '../popup';
import { ProgressSpinnerComponent } from '../progress-spinner';
import { MenuAdapter } from './menu-adapter';
import { MENU_CONSTANTS } from './menu-constants';
import { MenuFoundation } from './menu-foundation';
var template = require('./menu.html');
var styles = require('./menu.css');
var MenuComponent = /** @class */ (function (_super) {
    __extends(MenuComponent, _super);
    function MenuComponent() {
        var _this = _super.call(this) || this;
        TylerIconRegistry.define(tylIconArrowRight);
        _this._foundation = new MenuFoundation(new MenuAdapter(_this));
        attachShadowTemplate(_this, MENU_CONSTANTS.elementName, template, styles);
        return _this;
    }
    Object.defineProperty(MenuComponent, "observedAttributes", {
        get: function () {
            return [
                MENU_CONSTANTS.attributes.OPEN,
                MENU_CONSTANTS.attributes.PLACEMENT,
                MENU_CONSTANTS.attributes.SELECTED_INDEX,
                MENU_CONSTANTS.attributes.SELECTED_VALUE,
                MENU_CONSTANTS.attributes.DENSE,
                MENU_CONSTANTS.attributes.ICON_CLASS,
                MENU_CONSTANTS.attributes.PERSIST_SELECTION,
                MENU_CONSTANTS.attributes.MODE,
                MENU_CONSTANTS.attributes.SYNC_POPUP_WIDTH,
                MENU_CONSTANTS.attributes.HIGHLIGHT_FIRST,
                MENU_CONSTANTS.attributes.POPUP_CLASSES,
                MENU_CONSTANTS.attributes.OPTION_LIMIT,
                MENU_CONSTANTS.attributes.OBSERVE_SCROLL,
                MENU_CONSTANTS.attributes.OBSERVE_SCROLL_THRESHOLD
            ];
        },
        enumerable: true,
        configurable: true
    });
    MenuComponent.prototype.initializedCallback = function () {
        _super.prototype.initializedCallback.call(this);
        upgradeProperty(this, 'open');
        upgradeProperty(this, 'options');
        upgradeProperty(this, 'placement');
        upgradeProperty(this, 'selectedIndex');
        upgradeProperty(this, 'selectedValue');
        upgradeProperty(this, 'dense');
        upgradeProperty(this, 'iconClass');
        upgradeProperty(this, 'mode');
        upgradeProperty(this, 'popupPositionAdjustment');
        upgradeProperty(this, 'optionBuilder');
    };
    MenuComponent.prototype.connectedCallback = function () {
        var _this = this;
        if (this.children.length) {
            this._foundation.initialize();
        }
        else {
            ensureChildren(this).then(function () { return _this._foundation.initialize(); });
        }
    };
    MenuComponent.prototype.attributeChangedCallback = function (name, oldValue, newValue) {
        _super.prototype.attributeChangedCallback.call(this, name, oldValue, newValue);
        switch (name) {
            case MENU_CONSTANTS.attributes.OPEN:
                this._foundation.open = isDefined(newValue);
                break;
            case MENU_CONSTANTS.attributes.PLACEMENT:
                this._foundation.placement = newValue;
                break;
            case MENU_CONSTANTS.attributes.SELECTED_INDEX:
                this._foundation.selectedIndex = Number(newValue);
                break;
            case MENU_CONSTANTS.attributes.SELECTED_VALUE:
                this._foundation.selectedValue = newValue;
                break;
            case MENU_CONSTANTS.attributes.DENSE:
                this._foundation.dense = this.hasAttribute(MENU_CONSTANTS.attributes.DENSE);
                break;
            case MENU_CONSTANTS.attributes.ICON_CLASS:
                this._foundation.iconClass = newValue;
                break;
            case MENU_CONSTANTS.attributes.PERSIST_SELECTION:
                this.persistSelection = coerceBoolean(newValue);
                break;
            case MENU_CONSTANTS.attributes.MODE:
                this.mode = newValue;
                break;
        }
    };
    MenuComponent.prototype.disconnectedCallback = function () {
        this._foundation.disconnect();
    };
    /** Force propagates the key event from another element this component. */
    MenuComponent.prototype.propagateKeyEvent = function (evt) {
        this._foundation.onKeydown(evt);
    };
    __decorate([
        FoundationProperty()
    ], MenuComponent.prototype, "open", void 0);
    __decorate([
        FoundationProperty()
    ], MenuComponent.prototype, "options", void 0);
    __decorate([
        FoundationProperty()
    ], MenuComponent.prototype, "selectedIndex", void 0);
    __decorate([
        FoundationProperty()
    ], MenuComponent.prototype, "selectedValue", void 0);
    __decorate([
        FoundationProperty()
    ], MenuComponent.prototype, "placement", void 0);
    __decorate([
        FoundationProperty()
    ], MenuComponent.prototype, "dense", void 0);
    __decorate([
        FoundationProperty()
    ], MenuComponent.prototype, "iconClass", void 0);
    __decorate([
        FoundationProperty()
    ], MenuComponent.prototype, "persistSelection", void 0);
    __decorate([
        FoundationProperty()
    ], MenuComponent.prototype, "mode", void 0);
    __decorate([
        FoundationProperty()
    ], MenuComponent.prototype, "popupPositionAdjustment", void 0);
    __decorate([
        FoundationProperty()
    ], MenuComponent.prototype, "optionBuilder", void 0);
    __decorate([
        FoundationProperty({ set: false })
    ], MenuComponent.prototype, "popupElement", void 0);
    MenuComponent = __decorate([
        CustomElement({
            name: MENU_CONSTANTS.elementName,
            dependencies: [
                PopupComponent,
                ListComponent,
                LinearProgressComponent,
                ProgressSpinnerComponent
            ]
        })
    ], MenuComponent);
    return MenuComponent;
}(ListDropdownAware));
export { MenuComponent };
